<template>
  <b-form>
    <b-row>
      <b-col
        v-for="socialField in socialInputs"
        :key="socialField.dataField"
        cols="12"
        md="6"
        lg="4"
      >
        <b-form-group
          :label="socialField.label"
          :label-for="socialField.dataField"
        >
          <b-input-group class="input-group-merge">
            <b-input-group-prepend is-text>
              <font-awesome-icon
                :icon="[ 'fab', socialField.icon ]"
                class="icon"
                size="lg"
              />
            </b-input-group-prepend>
            <b-form-input
              :id="socialField.dataField"
              v-model="form[socialField.dataField]"
              type="url"
              @change="checkDiff"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <!-- Action Buttons -->
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="mb-1 mb-sm-0 mr-0 mr-sm-1"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          :disabled="btnDisable"
          @click="saveChanges"
        >
          <div v-if="submit">
            <b-spinner small />
            <span class="sr-only">更新中...</span>
          </div>
          <div v-else-if="!success">
            儲存變更
          </div>
          <div v-else-if="success">
            已儲存
          </div>
        </b-button>
        <b-button
          v-if="btnReset"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="outline-secondary"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          @click="setDefault"
        >
          取消
        </b-button>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import { mapGetters } from 'vuex'
import store from '@/store'
import {
  BRow, BCol, BForm, BFormGroup, BFormInput, BButton, BInputGroup, BInputGroupPrepend, BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BRow, BCol, BForm, BFormGroup, BFormInput, BButton, BInputGroup, BInputGroupPrepend, BSpinner,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      socialInputs: [
        {
          icon: 'facebook-f',
          dataField: 'facebook',
          label: 'facebook',
        },
        {
          icon: 'instagram',
          dataField: 'instagram',
          label: 'instagram',
        },
        {
          icon: 'line',
          dataField: 'line',
          label: 'line',
        },
        {
          icon: 'google-plus-g',
          dataField: 'google',
          label: 'google',
        },
      ],
      form: {
        line: null,
        google: null,
        facebook: null,
        instagram: null,
      },
      btnDisable: true,
      success: false,
      submit: false,
      btnReset: false,
    }
  },
  computed: {
    ...mapGetters(['user', 'campaign']),
  },
  mounted() {
    this.setDefault()
  },
  methods: {
    setDefault() {
      this.form = {
        line: (this.campaign.socialMedia && this.campaign.socialMedia.line) ? this.campaign.socialMedia.line : null,
        google: (this.campaign.socialMedia && this.campaign.socialMedia.google) ? this.campaign.socialMedia.google : null,
        facebook: (this.campaign.socialMedia && this.campaign.socialMedia.facebook) ? this.campaign.socialMedia.facebook : null,
        instagram: (this.campaign.socialMedia && this.campaign.socialMedia.instagram) ? this.campaign.socialMedia.instagram : null,
      }
      this.btnDisable = true
      this.btnReset = false
      this.submit = false
    },
    checkDiff() {
      this.btnDisable = true
      this.btnReset = false
      Object.entries(this.form).forEach(([key, value]) => {
        if ((!this.isEmpty(this.campaign.socialMedia) && this.campaign.socialMedia[key] !== value) || (this.isEmpty(this.campaign.socialMedia) && (value !== null && value !== ''))) {
          this.btnReset = true
          this.btnDisable = false
        }
      })
      Object.entries(this.form).forEach(([key, value]) => {
        if (value !== '' && value !== null && !value.toLowerCase().includes(key)) {
          this.btnDisable = true
        }
      })
    },
    saveChanges() {
      this.submit = true
      this.btnDisable = true

      store.dispatch('updateCampaignSocial', {
        data: this.form,
        campaign: this.campaign,
        cuid: this.user.uid,
      }).then(() => {
        this.success = true
        this.submit = false
      }).catch(() => {
        this.submit = false
      })
    },
  },
}
</script>

<style>

</style>
